import { HeadingProps } from '@chakra-ui/react';
import { Heading } from 'components/UI';

const PageSubtitle = ({ children, ...props }: HeadingProps) => (
  <Heading as="h2" fontWeight="medium" fontSize="xl" letterSpacing={5} color="base2FontColour.400" {...props}>
    {children}
  </Heading>
);

export { PageSubtitle };
